import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the HttpProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HttpProvider {
  // path:string='http://localhost:9586/api/'
  // images:string='http://localhost:9586'
  // pdf:string='http://localhost:9586'
  // path:string='http://192.168.1.102:9586/api/'
  // images:string='http://192.168.1.102:9586'
  // pdf:string='http://192.168.1.102:9586'
  path:string='https://apiavaflex.mansolutions.app/api/'
  images:string='https://avaflex.nbg1.your-objectstorage.com/public'
  pdf:string='https://avaflex.nbg1.your-objectstorage.com/public'
constructor(public http: HttpClient) {}
  get(url){
    return this.http.get(this.path + url)
  }
  post(url, data){
    return this.http.post(this.path + url, data)
  }
  put(url, data){
    return this.http.put(this.path + url, data)
  }
  delete(url){
    return this.http.delete(this.path + url)
  }
}



// WEBPACK FOOTER //
// ./src/providers/http/http.ts